// extracted by mini-css-extract-plugin
module.exports = {"root":"Paper-module--root--1t08J","hoverEffect":"Paper-module--hoverEffect--22LGB"};